import Dashboard from "./Dashboard";

const Cta = () => {
  return (
    

         <Dashboard/>
  
  );
};

export default Cta;
